<template>
    <div class='button_root'>

        <el-tooltip
            class="box-item"
            effect="dark"
            content="https://pypi.org/project/shared-atomic-enterprise/"
            placement="bottom"
        >
        <el-button class="button_middle button1" @click="download()">
            <div class='lines'>
                <div class='line1'>{{t('__download')}}</div>
                <div class='line2'>{{t('__install')}}</div>
            </div>
            <svg class="icon-font">
                <use xlink:href="#icon-xiazai"></use>
            </svg>
        </el-button>
        </el-tooltip>
        <el-tooltip
            class="box-item"
            effect="dark"
            content="mailto:shared_atomic_enterprise_subscriber@sharedatomic.top"
            placement="bottom"
        >
        <el-button class="button_middle button2" @click="mail_list()">
            <div class='lines'>
                <div class='line1'>{{t('__mail_list')}}</div>
                <div class='line2' v-html="t('__know')"/>
            </div>
            <svg class="icon-font">
                <use xlink:href="#icon-xudingshichang"></use>
            </svg>
        </el-button>
        </el-tooltip>

        <el-tooltip
            class="box-item"
            effect="dark"
            content="https://onlinelibrary.wiley.com/journal/1097024x/"
            placement="bottom"
        >
        <el-button class="button_middle button3" @click="publish()">
            <div class='lines'>
                <div class='line1'>{{t('__article')}}</div>
                <div class='line2' v-html="t('__publish')"/>
            </div>
            <svg class="icon-font">
                <use xlink:href="#icon-tushuchuban"></use>
            </svg>
        </el-button>
        </el-tooltip>

        <el-tooltip
            class="box-item"
            effect="dark"
            content="/payment"
            placement="bottom"
        >
        <el-button class="button_middle button4" @click="buy()">
            <div class='lines'>
                <div class='line1'>{{t('__buy')}}</div>
                <div class='line2' v-html="t('__support')"/>
            </div>
            <svg class="icon-font">
                <use xlink:href="#icon-qiyekehu"></use>
            </svg>
        </el-button>
        </el-tooltip>
    </div>
</template>


<script>
import { ElButton } from 'element-plus'
import { ElTooltip } from 'element-plus'
import { useI18n } from "vue-i18n"

export default {
    components: {
        ElButton,
        ElTooltip
    },

    setup() {
        let {t} = useI18n(
            {
                messages: {
                    'en': {
                        "__download": "PYPI Download",
                        '__mail_list': 'Subscribe Maillist',
                        '__article': 'Academic Article',
                        '__buy': 'Buy Enterprise Version',
                        '__install': "Download from PYPI mirrors",
                        '__know': "Acquire the latest message<br/>of products",
                        '__publish': "Publisch on academic<br/>article SPE",
                        '__support': "Enjoy the enterprise level<br/>custom support"
                    },
                    'zh_CN': {
                        "__download": "PYPI下载",
                        '__mail_list': '续订邮件列表',
                        '__article': '学术文献',
                        '__buy': '购买企业版',
                        '__install': "利用国内pypi镜像快速安装",
                        '__know': "获悉产品的最新消息",
                        '__publish': "在国际学术期刊SPE上发表",
                        '__support': "享受企业级后期支持"
                    },
                    'zh_HK': {
                        "__download": "PYPI下載",
                        '__mail_list': '續訂郵件列錶',
                        '__article': '學術文獻',
                        '__buy': '購買企業版',
                        '__install': "利用國內pypi鏡像快速安裝",
                        '__know': "穫悉產品的最新消息",
                        '__publish': "在國際學術期刊SPE上發表",
                        '__support': "享受企業級後期支持"
                    },
                    'zh_TW': {
                        "__download": "PYPI下載",
                        '__mail_list': '續訂郵件列錶',
                        '__article': '學術文獻',
                        '__buy': '購買企業版',
                        '__install': "利用國內pypi鏡像快速安裝",
                        '__know': "穫悉產品的最新消息",
                        '__publish': "在國際學術期刊SPE上發表",
                        '__support': "享受企業級後期支持"
                    }
                }
            }
        );

        return {
            t
        }
    },

    methods: {
        buy() {
            this.$router.push("/payment");
        },
        download() {
            let url = 'pypi.org/project/shared-atomic-enterprise/' // 这里的地址前面就不用加协议了'http:// 或者 https://' 下面一句话就是处理这个的。
            let path = //window.location.protocol +  
                        "https://" + url
            window.location.href = path
        },
        publish() {
            let url = 'onlinelibrary.wiley.com/journal/1097024x/' // 这里的地址前面就不用加协议了'http:// 或者 https://' 下面一句话就是处理这个的。
            let path = //window.location.protocol +  
                        "https://" + url
            window.location.href = path
        },
        mail_list() {
            let email = 'shared_atomic_enterprise_subscriber@sharedatomic.top';
            let mailto = 'mailto:' + encodeURIComponent(email);
            window.location.href = mailto;
        }
    }
}
</script>

<style scoped>
    .icon-font {
      vertical-align: center;
      fill: currentColor;
      overflow: hidden;
    }

    .button_root {
        position: relative;
    }

    .button_middle {
        border-radius: 0;
    }

    .button1 {
        position: absolute;
        left: 0;
    }

    .button2 {
        position: absolute;
    }

    .button3 {
        position: absolute;
    }

    .button4 {
        position: absolute;
    }

    .lines {
        position: relative;
        top:0;
        left:0;
    }

    .line1 {
        position: absolute;
        left:0;
    }

    .line2 {
        position: absolute;
        bottom:0;
        left:0;
        color: rgb(180, 180, 180);
    }

    @media screen and (max-width: 768px){
        .icon-font {
            width: 10vw;
            height: 10vw;
            position: absolute;
            top: 0.5vw;
            left: 6.5vw;
        }

        .button_middle {
            height: 20vw;
            width: 25vw;
            padding: 0 0;
        }

        .button2 {
            left: 21.8vw;
        }

        .button3 {
            left: 47vw;
        }

        .button4 {
            left: 72vw;
        }

        .lines {
            height: 6.3vw;
            width: 25vw;
            top:4vw;
            text-align: center;
        }

        .line1 {
            width: 25vw;
            height: 2.1vw;
            font-size: 2.1vw;
            top:2vw;
            left: -0.3vw;
        }

        .line2 {
            width: 25vw;
            font-size: 1.7vw;
            top:5vw;
            left: 0;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1080px) {
        .icon-font {
            width: 8vw;
            height: 8vw;
            position: absolute;
            top: 1vw;
            left: 8vw;
        }

        .button_middle {
            height: 16vw;
            width: 25vw;
            padding: 0 0;
        }

        .button2 {
            left: 23.5vw;
        }

        .button3 {
            left: 48.5vw;
        }

        .button4 {
            left: 73.5vw;
        }

        .lines {
            height: 10vw;
            width: 25vw;
            top:4.3vw;
            text-align: center;
        }

        .line1 {
            width: 100%;
            font-size: 2.3vw;
            top:2vw;
            left: -0.2vw;
        }

        .line2 {
            width: 100%;
            font-size: 1.8vw;
            top:5vw;
            left: -0.2vw;
        }
    }

    @media screen and (min-width: 1080px){
        .icon-font {
            width: 0.3rem;
            height: 0.3rem;
        }

        .button_middle {
            height: 0.4rem;
            width: 1.55rem;
            padding: 0.1rem 0.05rem;
        }

        .button2 {
            left: 1.46rem;
        }

        .button3 {
            left: 3.005rem;
        }

        .button4 {
            left: 4.55rem;
        }

        .lines {
            height: 0.3rem;
            width: 1.05rem;
        }

        .line1 {
            top:0.05rem;
            height: 0.15rem;
        }

        .line2 {
            text-align: left;
            height: 0.1rem;
            width: 0.5rem;
            font-size: 0.07rem;
            top: 0.19rem;
        }

    }


</style>